<script>
	export let name;
	name;

	import { nav } from './store.js'
	import Home from "./home.svelte";
	import Contact from "./contact.svelte";
	import About from "./about.svelte";
	import Stat from "./stat.svelte";
	import Vault from "./vault.svelte";
	import Nav from "./nav.svelte";


</script>

<main>
	<Nav/>
	<Contact/>

	{#if ($nav == "home")}
	<Home/>
	{:else if ($nav == "about")}
	<About/>
	{:else if ($nav == "market")}
	<Stat/>
	{:else if ($nav == "vault")}
	<Vault/>
	{/if}

	<div class="wipeout"></div>
</main>

<style>
	main{
		/* ? */
		width: 100vw;
		height: 100vh;
		overflow: hidden;
	}
	.wipeout{
		background: #091B1C;
		width: 110vw;
		height : 110vh;
		position : absolute;
		top : 0px;
		left : 105vw;
		z-index: 30;
		transition : all 0.8s ease;
	}
</style>